export * from './BasePreloader.vue';
export { default } from './BasePreloader.vue';
